export enum DriveItemType {
  Folder = 'folder',
  CarbonViewer = 'cv',
  LodViewer = 'lod',
  ImageViewer = 'img',
  DMIndustrial = 'dmind',
}
